export const experiencesData = [
  {
    id: 1,
    title: "Samsung Innovation Campus",
    company: "Samsung Electronic Indonesia",
    period: "2024",
    description: "Mempelajari tentang pengembangan teknologi IoT menggunakan bahasa pemrograman Python dan membuat simulasi MQTT di Wokwi dan Mosquitto",
    technologies: ["Python", "IoT"]
  },
  {
    id: 2,
    title: "Memimpin Project & Backend Developer",
    company: "PT Narantraya",
    period: "2024 - 2025",
    description: "Memimpin tim yang mencakup backend dan frontend untuk membuat proyek situs web manajemen topup. Menggunakan Express.js dan React.js",
    technologies: ["React.js", "Express.js", "Golang", "Team Leadership"]
  },
  {
    id: 3,
    title: "Global Game Jam 2025",
    company: "Global Game Jam",
    period: "2025",
    description: "Saya membuat game seperti game Doom klasik dalam 3 hari bersama teman-teman saya. Saya menjadi game programmer dan game design.",
    technologies: ["Unity", "C#", "Game Design"]
  },
  {
    id: 4,
    title: "Become CEO Lightcess Production",
    company: "Lightcess Production",
    period: "2024 - 2025",
    description: "Saya menjadi CEO sebuah studio game yang saya buat sendiri bersama teman-teman sekolah saya",
    technologies: ["Leadership", "Game Developer"]
  },
  {
    id: 5,
    title: "Unity Certified Associate",
    company: "Unity x Google Play Store",
    period: "2025",
    description: "Saya berkesempatan mengikuti sertifikasi game developer dari acara resmi Unity x Google Playstore, saya belajar banyak mengenai teknis pembuatan game, pra sampai post produksi, dan saya bertemu dengan orang-orang hebat yang banyak sudah terjun ke dunia industri game developer di Indonesia.",
    technologies: ["Unity", "Game Developer", "3D Design", "Game Programmer"]
  },
  {
    id: 6,
    title: "Panitia Global Game Jam Bogor 2026",
    company: "Game developer Bogor",
    period: "2026",
    description: "Saya diberi kesempatan untuk menjadi panitia Global Game Jam di kota Bogor, sebagai panitia saya membantu para peserta untuk memenuhi kebutuhan mereka saat acara berjalan dan saya menjadi bagian tim dokumentasi.",
    technologies: ["Management", "Public Relation", "Event Organizer"]
  },
];
